import React from 'react';
import I18N from '@leverege/i18n';
import { LoadingView } from '@leverege/molten/views';
import { Toast } from '@leverege/ui-elements';
import DefaultDialog from '../../components/DefaultDialog';
import RecovrReconciliation from '../../util/RecovrReconciliation';
import { jsx as _jsx } from "react/jsx-runtime";
const {
  t,
  tIcon
} = I18N.ns('recovr.lost.reconcileLost.ReconcileLostDialog');
export default function ReconcileLostDialog(props) {
  const {
    losts,
    actions,
    show,
    onClose
  } = props;
  const onOkay = async () => {
    const closeLoading = LoadingView.showDialog('Reconciling Lost Locator');
    try {
      await RecovrReconciliation.reconcileLost({
        losts,
        actions
      });
    } catch (err) {
      console.log(`Could not reconcile locator: ${err}`);
      Toast.error('Error requesting lost locator reconciliation.');
    }
    closeLoading();
    onClose();
  };
  return /*#__PURE__*/_jsx(DefaultDialog, {
    show: show,
    onClose: onClose,
    title: t('title'),
    titleIcon: tIcon('icon'),
    submitText: t('okay'),
    onSubmit: onOkay,
    children: t('message')
  });
}